import { initService } from "helpers/initService";
import { uuidv7 } from "helpers/uuidv7";

class SessionService {
  public getOrCreateTabId() {
    let tabId = sessionStorage.getItem("tab_identifier");

    if (!tabId) {
      tabId = uuidv7();
      sessionStorage.setItem("tab_identifier", tabId);
    }

    return tabId;
  }
}

let sessionService: Readonly<SessionService> | null = null;

export const getSessionService = () => {
  if (!sessionService) {
    sessionService = initService(() => new SessionService());
  }
  return sessionService;
};
